import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';
import { PaginatedResponse } from '@/app/types/pagination';

interface Partner {
  id: number;
  name: string;
  website_url: string;
  logo_path: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export function usePartners() {
  const lang = useLocale();
  return useQuery<PaginatedResponse<Partner>>({
    queryKey: ['partners', lang],
    enabled: true,
    queryFn: async () => {
      const res = await http.get(`/api/partners?lang=${lang}`);
      return res.data;
    },
  });
}
